import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scroll restoration + lightweight document.title updater.
 * Pass `title` / `description` from each page.
 */
export default function PageMeta({ title, description }) {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
    }, [pathname]);

    useEffect(() => {
        if (title) document.title = `${title} — Perceptiqx`;
        if (description) {
            let tag = document.querySelector('meta[name="description"]');
            if (!tag) {
                tag = document.createElement("meta");
                tag.setAttribute("name", "description");
                document.head.appendChild(tag);
            }
            tag.setAttribute("content", description);
        }
    }, [title, description]);

    return null;
}
